import { hFetch } from '@/lib/hfetch';
import type { WorkflowScheduledActionInstanceStatus } from './entity_types/workflow/WorkflowScheduledActionInstance';

type UpdateWorkflowScheduledActionInstanceArgs = {
  id: number;
  status: WorkflowScheduledActionInstanceStatus;
};

export const updateWorkflowScheduledActionInstance = ({ id, status }: UpdateWorkflowScheduledActionInstanceArgs) => {
  return hFetch({
    url: `/api/workflow_scheduled_action_instances/${id}`,
    method: 'PATCH',
    payload: { workflow_scheduled_action_instance: { status } },
  });
};
